export const getEntityValue = <T>(name: string, entities: { entity: string; value?: unknown }[] | undefined): T | undefined => {
  return entities?.find((entityPair): entityPair is { entity: string; value?: T } => entityPair.entity === name)?.value;
};
